export default __webpack_public_path__ + "static/hero_partnership_mobile_img_3-ddd53de5299c2da536e239c853f93742.png";